import { Component, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { AccionesDialog } from '@models/base/identificadores.model';
import { CreateMenuRequest } from '@models/seguridad/menu/createMenuRequest.model';
import { MenuService } from '@services/menu/menu.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { DialogCreateMenuComponent } from './dialog-create-menu/dialog-create-menu.component';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatTableModule } from '@angular/material/table';
import { ButtonCancelDialogComponent } from '@component/button-cancel-dialog/button-cancel-dialog.component';
import { AppRolesDirective } from '@directives/appRoles/app-roles.directive';

@Component({
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatCardModule, MatIconModule, MatButtonModule, MatDividerModule, NgxSpinnerModule, MatTableModule, MatSliderModule, MatSlideToggleModule, CommonModule, MatMenuModule, MatDialogModule, MatDatepickerModule, MatExpansionModule, AppRolesDirective, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatSelectModule, MatOptionModule, MatButtonModule, MatIconModule, ButtonCancelDialogComponent,
    NgxSpinnerModule],
  selector: 'app-crear-menu',
  templateUrl: './crear-menu.component.html',
  styleUrls: ['./crear-menu.component.css']
})
export class CrearMenuComponent implements OnInit {
  formBuilder = new FormBuilder;
  form: any;
  get f() { return this.form.controls; }
  constructor(
    public dialogRef: MatDialogRef<DialogCreateMenuComponent>,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private menuService: MenuService
  ) {

    this.form = this.formBuilder.group({
      Descripcion: ["", Validators.compose([Validators.required,])],
      Icono: ["", Validators.compose([Validators.required,])],
      Path: ["", Validators.compose([])],
      Nivel: ["", Validators.compose([Validators.required])],
      IdMenuPadre: ["", Validators.compose([Validators.required])],
    })
  }

  ngOnInit(): void {

  }

  doAction() {

    let createMenuRequest: CreateMenuRequest = new CreateMenuRequest
    createMenuRequest.descripcion = this.form.controls["Descripcion"].value
    createMenuRequest.icon = this.form.controls["Icono"].value.toLowerCase()
    createMenuRequest.path = this.form.controls["Path"].value.toLowerCase()
    createMenuRequest.nivel = parseInt(this.form.controls["Nivel"].value)
    createMenuRequest.idMenuPadre = parseInt(this.form.controls["IdMenuPadre"].value)
    this.create(createMenuRequest)
  }

  closeDialog() {
    this.dialogRef.close({ event: AccionesDialog.Cancelar });
  }

  create(createMenuRequest: CreateMenuRequest) {
    this.spinner.show("spCrearMenu")
    this.menuService.create(createMenuRequest)
      .subscribe(
        data => {
          this.spinner.hide("spCrearMenu")
          this.snackBar.showSuccess("Registro agregado correctamente.", "Exito");
          this.dialogRef.close({ event: AccionesDialog.Agregar });
        },
        error => {
          this.spinner.hide("spCrearMenu")
          this.snackBar.showError(error, "Error");
        }
      )
  }

}

